export * from './iconFontAwesomeTextformattingCheck';
export * from './iconFontAwesomeTextformattingList';
export * from './iconFontAwesomeTextformattingFont';
export * from './iconFontAwesomeTextformattingStrikethrough';
export * from './iconFontAwesomeTextformattingTable';
export * from './iconFontAwesomeTextformattingIcons';
export * from './iconFontAwesomeTextformattingSquareCheck';
export * from './iconFontAwesomeTextformattingCircleCheck';
export * from './iconFontAwesomeTextformattingHeading';
export * from './iconFontAwesomeTextformattingICursor';
export * from './iconFontAwesomeTextformattingSubscript';
export * from './iconFontAwesomeTextformattingBorderNone';
export * from './iconFontAwesomeTextformattingUnderline';
export * from './iconFontAwesomeTextformattingTextWidth';
export * from './iconFontAwesomeTextformattingTextSlash';
export * from './iconFontAwesomeTextformattingTextHeight';
export * from './iconFontAwesomeTextformattingTableList';
export * from './iconFontAwesomeTextformattingTableColumns';
export * from './iconFontAwesomeTextformattingTableCellsRowLock';
export * from './iconFontAwesomeTextformattingTableCellsLarge';
export * from './iconFontAwesomeTextformattingTableCellsColumnLock';
export * from './iconFontAwesomeTextformattingTableCells';
export * from './iconFontAwesomeTextformattingSuperscript';
export * from './iconFontAwesomeTextformattingSpellCheck';
export * from './iconFontAwesomeTextformattingRectangleList';
export * from './iconFontAwesomeTextformattingParagraph';
export * from './iconFontAwesomeTextformattingOutdent';
export * from './iconFontAwesomeTextformattingListUl';
export * from './iconFontAwesomeTextformattingListOl';
export * from './iconFontAwesomeTextformattingListCheck';
export * from './iconFontAwesomeTextformattingItalic';
export * from './iconFontAwesomeTextformattingIndent';
export * from './iconFontAwesomeTextformattingHighlighter';
export * from './iconFontAwesomeTextformattingFilterCircleXmark';
export * from './iconFontAwesomeTextformattingCheckDouble';
export * from './iconFontAwesomeTextformattingBorderTopLeft';
export * from './iconFontAwesomeTextformattingBorderAll';
export * from './iconFontAwesomeTextformattingBold';
export * from './iconFontAwesomeTextformattingAlignRight';
export * from './iconFontAwesomeTextformattingAlignLeft';
export * from './iconFontAwesomeTextformattingAlignJustify';
export * from './iconFontAwesomeTextformattingAlignCenter';
